import { darken, lighten } from "@mui/material";
import { defaultTenantPalette, smartTowerColors } from "./tokens";

const { primary, accent, success, warning } = defaultTenantPalette;

// Palette da tela de login (SmartTower). Congelado de propósito: a tela de
// login não acompanha o tema da aplicação.
export const loginPalette = {
  mode: "light" as const,
  accentText: smartTowerColors.blue500,
  highlight: smartTowerColors.blue500,
  // Não usado pelo login; só completa o tipo do Palette.
  brand: { primary, accent, success, warning },
  primary: {
    main: "#FAFBFF",
    light: "#F9F9F9",
    dark: smartTowerColors.blue500,
    contrastText: "#2A2B2F",
  },
  secondary: {
    main: "#F2F6FA",
    light: "#323232",
    dark: "#F2F2F2",
    contrastText: "#212121",
  },
  background: {
    default: "#F2F2F2",
    paper: "#F9F9F9",
  },
  text: {
    primary: "#2A2B2F",
    secondary: "#2A2B2F",
  },
  warning: {
    main: smartTowerColors.warning,
    dark: smartTowerColors.warningHover,
    light: lighten(smartTowerColors.warning, 0.3),
    contrastText: "#fff",
  },
  success: {
    main: smartTowerColors.success,
    dark: smartTowerColors.successHover,
    light: lighten(smartTowerColors.success, 0.3),
    contrastText: "#fff",
  },
  error: {
    main: smartTowerColors.danger,
    dark: smartTowerColors.dangerHover,
    light: lighten(smartTowerColors.danger, 0.3),
    contrastText: "#fff",
  },
  info: {
    main: smartTowerColors.info,
    light: smartTowerColors.iceCyan300,
    dark: darken(smartTowerColors.info, 0.2),
    contrastText: "rgba(0,0,0,0.87)",
  },
};
